import { useSelector } from 'react-redux';
import type { FunctionComponent } from 'react';

import { getSelectedReleaseId } from '../../redux/project_grouping/selectors';
import Loader from '../generic/Loader';

import IssuesContainer from './IssuesContainer';
import type { IssuesContainerProps } from './IssuesContainer';

/**
 * ReleaseGroupIssuesContainer wraps the regular issues container when
 * we are on the release group issues page. Why do we need this only
 * for release groups? Because to set the scope for release groups, we
 * need the selectedReleaseId. Unlink project issues, this isn't stored
 * in the URL params but instead lives in Redux.
 *
 * This component holds off on rendering the IssuesContainer until
 * we have that selectedReleaseId, since IssuesContainer needs to
 * set the scope when it is *mounted*.
 */
const ReleaseGroupIssuesContainer: FunctionComponent<IssuesContainerProps> = ({
  params,
  children,
  location,
}) => {
  const projectReleaseId: number | undefined = useSelector(getSelectedReleaseId);
  if (params.projectGroupId && !projectReleaseId) {
    return <Loader />;
  }
  return (
    <IssuesContainer params={{ ...params, projectReleaseId }} location={location}>
      {children}
    </IssuesContainer>
  );
};

export default ReleaseGroupIssuesContainer;
